const INITIAL_STATE = {
  tarifarioList: [],
  tarifario: null,
  produtos: [],
  parceiros: [],
  fornecedores: [],
  fornecedoresTipo: [],
  /** Segmento 12 + clientes com veículo — select do Gerar mapa. */
  fornecedoresTransporteMapa: [],
  tourProdutos: [],
  tarifarioProdutos: null
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'TARIFARIO_FETCH':
      return { ...state, tarifarioList: action.payload }
    case 'TARIFARIO_CONSULTA_FETCH':
      return { ...state, tarifarioProdutos: action.payload }
    case 'TARIFARIO_SET':
      const tarifario = action.payload
    //  console.log(tarifario, 'tarifario')
      const tarifarioSegmentos = tarifario.segmentos.map(ts => {
        return { label: ts.segmento.seg_nome, value: ts.segmento.seg_id }
      })
      const tarifarioClientes = tarifario.clientes.map(cliente => {
        return { label: cliente.parceiro.pessoa.pes_nome, value: cliente.parceiro.par_id }
      })

      const tarifarioItems = tarifario.items.map(ti => {
        return {
          fornecedor: ti.fornecedor      ? { value: ti.fornecedor.par_id, label: ti.fornecedor.pessoa.pes_nome } : {label:"aqui"},
          tour:       ti.produto.passeio ? { value: ti.produto.passeio.pas_idtour, label: ti.produto.passeio.tour.tou_nome, passeios: ti.produto.passeio.tour.passeios } : {},
          produto:    ti.produto         ? { value: ti.produto.pro_id, label: ti.produto.pro_nome } : {},
          valorAdt:   ti.ite_valor_adt.replace('.', ','),
          valorChd:   ti.ite_valor_chd.replace('.', ','),
          valorInf:   ti.ite_valor_inf.replace('.', ','),
          valorJvm:   ti.ite_valor_jvm.replace('.', ','),
          valorIds:   ti.ite_valor_ids.replace('.', ',')
        }
      })

      const tarifarioEdit = { ...tarifario, segmentos: tarifarioSegmentos, items: tarifarioItems, clientes: tarifarioClientes }
      return { ...state, tarifario: tarifarioEdit }

    case 'TARIFARIO_FETCH_PRODUTOS':
      return { ...state, produtos: action.payload }
    case 'TARIFARIO_FETCH_FORNECEDORES':
      return { ...state, fornecedores: action.payload }
    case 'TARIFARIO_FETCH_CLIENTES':
      return { ...state, parceiros: action.payload }
    case 'TARIFARIO_FETCH_TIPO_FORNECEDORES':
      return { ...state, fornecedoresTipo: action.payload }
    case 'TARIFARIO_FETCH_FORNECEDORES_TRANSPORTE_MAPA':
      return { ...state, fornecedoresTransporteMapa: action.payload }
    case 'TARIFARIO_GET_TOUR_PRODUTOS':
      return { ...state, tourProdutos: action.payload }
    case 'TARIFARIO_RESET':
      return { ...state, tarifario: null }
    case 'TARIFARIO_GET':
      return { ...state, tarifario: action.payload.tarifario }
    case 'TARIFARIO_ABRIR_GRUPO':

      const tarifarioList = [...state.tarifarioList]
      const index = action.index
      const teste = { ...tarifarioList[index] }
      teste.grupoAberto = !teste.grupoAberto
      tarifarioList[index] = teste
      return { ...state, tarifarioList }
    default:
      return state
  }
}